<template>
    <div class="payment">
        <div ref="dropin"></div>

        <v-flex xs12 class="button-recharge-container">
            <v-layout wrap row>
                <v-flex xs12>
                    <button ref="submit" :disable="disabled || loading"
                            class="button-recharge v-btn theme--light coloricon">
                        {{$vuetify.t("$vuetify.Braintree.recharge")}}
                    </button>
                </v-flex>
            </v-layout>
        </v-flex>

        <generic-popup-response-status :showPopup="showPopupSuccess"
                                       :success="true"
                                       @hidePopup="showPopupSuccess=false">
            <template #title>
                {{$vuetify.t("$vuetify.Braintree.successPayment")}}
            </template>
            {{$vuetify.t("$vuetify.Braintree.successPaymentMessage")}}
        </generic-popup-response-status>

        <generic-popup-response-status :showPopup="showPopupError"
                                       :success="false"
                                       @hidePopup="showPopupError=false">
            <template #title>
                {{$vuetify.t("$vuetify.Braintree.errorPayment")}}
            </template>
            {{$vuetify.t("$vuetify.Braintree.errorPaymentMessage")}}

        </generic-popup-response-status>


    </div>
</template>

<script>

    import dropIn from 'braintree-web-drop-in'
    import GenericPopupResponseStatus from './genericPopupResponseStatus'

    export default {
        data() {
            return {
                showPopupSuccess: false,
                showPopupError: false,
                errorMessages: [],
                loading: false, // When a payment is processed, prevents double clicks
                disabled: false // When a payment is successfully processed, the entire component is disabled

            }
        },
        props: {
            paymentAmount: {
                type: Number,
                default: 0.0
            },
            token: {
                required: true,
                type: String
            },
            locale: {
                type: String,
                default: 'en_US'
            },
            url: {
                type: String,
                default: '/pay'
            },
            btnText: {
                type: String,
                default: 'Pay'
            },
            btnClass: {
                type: String,
                default: 'btn btn-primary'
            },
            paypal: {
                type: Boolean,
                default: false
            }
        },
        mounted() {
            let vm = this
            // Create config
            let config = {
                authorization: this.token,
                container: this.$refs.dropin,
                locale: this.locale
            }
            // If Paypal is available
            if (this.paypal) {
                config.paypal = {
                    flow: 'vault'
                }
            }
            // Create dropin
            dropIn.create(config, function (createErr, instance) {
                vm.$emit('loaded')
                vm.$refs.submit.addEventListener('click', function () {
                    if (!vm.loading && !vm.disabled) {
                        instance.requestPaymentMethod(function (err, payload) {
                            if (err) {
                                // No payment method is available.
                                // An appropriate error will be shown in the UI.
                                vm.showPopupError = true
                                console.error(err)
                                return
                            }
                            vm.loading = true
                            vm.$emit("startSendNonce")
                            vm.pay(payload.nonce).then(() => {
                                instance.clearSelectedPaymentMethod();
                            })
                        })
                    }
                })
            })
        },
        methods: {
            async pay(nonce) {
                const NONCE_MUTATION = require("../graphql/mutations/braintreeCheckout.gql")

                const result = await this.$apollo.mutate({
                    client: "clientPrivate",
                    // Query
                    mutation: NONCE_MUTATION,
                    // Parameters
                    variables: {
                        amount: this.paymentAmount,
                        nonce: nonce
                    },

                })
                if (result.data.brainTreeCheckout._response.result) {
                    this.$emit('success')
                    this.showPopupSuccess = true
                    this.loading = false
                    //this.disabled = true

                } else {
                    this.$emit('fail', result.data.brainTreeCheckout._response.errors)
                    this.showPopupError = true
                    this.loading = false
                }


            }
        },
        components: {
            GenericPopupResponseStatus
        }

    }
</script>

<style scoped lang="scss">

    .payment {
        width: 100%;

        .button-recharge {
            margin-top: 16px;
            width: 250px;
            font-size: 20px;
            color: var(--v-primary-base);
            height: 50px;
            border-radius: 10px;
        }

        & /deep/ .braintree-heading, & /deep/ .braintree-option__label{
            color: var(--v-bluetext-base)
        }


    }


</style>